var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSpeedlimit20Before({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMax slice",
    viewBox: "0 0 1258 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n   .speedlimit20_before_svg__cls-2{fill:#a9bf5c}.speedlimit20_before_svg__cls-4{fill:#343a50}.speedlimit20_before_svg__cls-54,.speedlimit20_before_svg__cls-58{fill:#898989}.speedlimit20_before_svg__cls-12,.speedlimit20_before_svg__cls-25,.speedlimit20_before_svg__cls-6{fill:#fff}.speedlimit20_before_svg__cls-18,.speedlimit20_before_svg__cls-19,.speedlimit20_before_svg__cls-20,.speedlimit20_before_svg__cls-27,.speedlimit20_before_svg__cls-29,.speedlimit20_before_svg__cls-34,.speedlimit20_before_svg__cls-39,.speedlimit20_before_svg__cls-40,.speedlimit20_before_svg__cls-42,.speedlimit20_before_svg__cls-43,.speedlimit20_before_svg__cls-48,.speedlimit20_before_svg__cls-49,.speedlimit20_before_svg__cls-52,.speedlimit20_before_svg__cls-53,.speedlimit20_before_svg__cls-6,.speedlimit20_before_svg__cls-7,.speedlimit20_before_svg__cls-8,.speedlimit20_before_svg__cls-9{stroke:#343a50}.speedlimit20_before_svg__cls-11,.speedlimit20_before_svg__cls-18,.speedlimit20_before_svg__cls-19,.speedlimit20_before_svg__cls-20,.speedlimit20_before_svg__cls-27,.speedlimit20_before_svg__cls-29,.speedlimit20_before_svg__cls-34,.speedlimit20_before_svg__cls-39,.speedlimit20_before_svg__cls-42,.speedlimit20_before_svg__cls-43,.speedlimit20_before_svg__cls-48,.speedlimit20_before_svg__cls-54,.speedlimit20_before_svg__cls-57,.speedlimit20_before_svg__cls-58,.speedlimit20_before_svg__cls-6,.speedlimit20_before_svg__cls-60,.speedlimit20_before_svg__cls-64,.speedlimit20_before_svg__cls-65,.speedlimit20_before_svg__cls-7,.speedlimit20_before_svg__cls-8,.speedlimit20_before_svg__cls-9{stroke-miterlimit:10}.speedlimit20_before_svg__cls-29,.speedlimit20_before_svg__cls-34,.speedlimit20_before_svg__cls-49,.speedlimit20_before_svg__cls-52,.speedlimit20_before_svg__cls-6{stroke-width:2px}.speedlimit20_before_svg__cls-7{fill:#b01928}.speedlimit20_before_svg__cls-18,.speedlimit20_before_svg__cls-19,.speedlimit20_before_svg__cls-20,.speedlimit20_before_svg__cls-27,.speedlimit20_before_svg__cls-7{stroke-width:2.15px}.speedlimit20_before_svg__cls-8,.speedlimit20_before_svg__cls-9{fill:#936652;stroke-width:1.74px}.speedlimit20_before_svg__cls-9{fill:#ffccb8}.speedlimit20_before_svg__cls-13{fill:#343a51}.speedlimit20_before_svg__cls-11,.speedlimit20_before_svg__cls-15,.speedlimit20_before_svg__cls-49,.speedlimit20_before_svg__cls-53,.speedlimit20_before_svg__cls-65{fill:none}.speedlimit20_before_svg__cls-11,.speedlimit20_before_svg__cls-15{stroke:#343a51}.speedlimit20_before_svg__cls-11{stroke-width:.58px}.speedlimit20_before_svg__cls-14{fill:#ffb3ac}.speedlimit20_before_svg__cls-15,.speedlimit20_before_svg__cls-40,.speedlimit20_before_svg__cls-49,.speedlimit20_before_svg__cls-52,.speedlimit20_before_svg__cls-53{stroke-linecap:round;stroke-linejoin:round}.speedlimit20_before_svg__cls-15{stroke-width:1.16px}.speedlimit20_before_svg__cls-16{fill:#e67984}.speedlimit20_before_svg__cls-17{fill:#ff8795}.speedlimit20_before_svg__cls-18{fill:#525254}.speedlimit20_before_svg__cls-19{fill:#404040}.speedlimit20_before_svg__cls-20{fill:#ba1e2c}.speedlimit20_before_svg__cls-25{opacity:.32}.speedlimit20_before_svg__cls-26{fill:#969799}.speedlimit20_before_svg__cls-27{fill:#fcb042}.speedlimit20_before_svg__cls-29{fill:#3b3b3b}.speedlimit20_before_svg__cls-30{fill:#2cb4c3}.speedlimit20_before_svg__cls-34{fill:#8a2519}.speedlimit20_before_svg__cls-37,.speedlimit20_before_svg__cls-69{fill:#dedede}.speedlimit20_before_svg__cls-37,.speedlimit20_before_svg__cls-68{mix-blend-mode:multiply}.speedlimit20_before_svg__cls-39{fill:#ffccb5}.speedlimit20_before_svg__cls-39,.speedlimit20_before_svg__cls-54{stroke-width:3px}.speedlimit20_before_svg__cls-40{fill:#5eb0d7}.speedlimit20_before_svg__cls-40,.speedlimit20_before_svg__cls-43,.speedlimit20_before_svg__cls-48,.speedlimit20_before_svg__cls-53{stroke-width:3px}.speedlimit20_before_svg__cls-42,.speedlimit20_before_svg__cls-48,.speedlimit20_before_svg__cls-52{fill:#ffdccd}.speedlimit20_before_svg__cls-42{stroke-width:2.61px}.speedlimit20_before_svg__cls-43{fill:#b36375}.speedlimit20_before_svg__cls-54,.speedlimit20_before_svg__cls-57,.speedlimit20_before_svg__cls-58,.speedlimit20_before_svg__cls-60,.speedlimit20_before_svg__cls-64,.speedlimit20_before_svg__cls-65{stroke:#2c3d4f}.speedlimit20_before_svg__cls-55,.speedlimit20_before_svg__cls-57{fill:#2c3d51}.speedlimit20_before_svg__cls-57,.speedlimit20_before_svg__cls-58,.speedlimit20_before_svg__cls-60,.speedlimit20_before_svg__cls-64{stroke-width:1.67px}.speedlimit20_before_svg__cls-60{fill:#2d3e50}.speedlimit20_before_svg__cls-64{fill:#2c3d4f}.speedlimit20_before_svg__cls-65{stroke-width:4.47px}\r\n  "))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "speedlimit20_before_svg__Ebene_1",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "speedlimit20_before_svg__Tempo_20_Vorher",
    "data-name": "Tempo 20_Vorher"
  }, /*#__PURE__*/React.createElement("g", {
    id: "speedlimit20_before_svg__Wiese"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "362.31 967.13 0 966.13 0 1079.99 0 1079.99 362.31 967.13",
    className: "speedlimit20_before_svg__cls-2"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "901.44 969 1258 967.13 1258 1080 1258 1080 901.44 969",
    className: "speedlimit20_before_svg__cls-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "speedlimit20_before_svg__Himmel"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#a5d1d6",
    points: "-1 968.13 -.96 -1 1259 -1 1259 968.13 0 968.13 -1 968.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258 0v967.13H0V0h1258m2-2H-2v971.13h1262V-2z",
    className: "speedlimit20_before_svg__cls-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "speedlimit20_before_svg__Stra\\xDFe"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#898989",
    points: "-6.64 1080.99 357.49 968.76 902.29 969.34 1264.64 1081 -6.64 1080.99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.64 969.76l544.5.58L1258 1080H0l357.64-110.24m-.3-2l-.29.09L-.59 1078.08l-12.69 3.92h1284.56l-12.69-3.91-355.86-109.67-.29-.08h-.3l-544.5-.58z",
    className: "speedlimit20_before_svg__cls-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "speedlimit20_before_svg__Stra\\xDFenmarkierung"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "638.75 1002.57 626.63 1002.57 628.84 969.03 636.16 969.03 638.75 1002.57",
    className: "speedlimit20_before_svg__cls-6"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "641.56 1068.96 622.92 1068.96 625.35 1025.55 639.78 1025.55 641.56 1068.96",
    className: "speedlimit20_before_svg__cls-6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "speedlimit20_before_svg__Auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M510.07 798.74l27-12-27.47-25.9c-.58.28-40-7.59-40.62-7.31a26.88 26.88 0 00-3.91 2.31l-97.84-2.32-10 3.63c-.77-.37-2.29 2.33-3.06 2-.58-.28-.4 2.81-1 2.53l-30.07 28.3L353.81 805c14.48-8.64 26.68-17.5 46.18-16.12h48c19.01 3.68 45.74 5.57 62.08 9.86z",
    className: "speedlimit20_before_svg__cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.62 787.32h-57.18c-31.87 0-57.7 18.18-57.7 40.61L314.82 833h233.75l-32.25-5.06c0-22.44-25.83-40.62-57.7-40.62zm51.16 39.74H350.4v-.77c0-19.87 22.89-36 51.12-36h57.15c28.23 0 51.11 16.11 51.11 36z",
    className: "speedlimit20_before_svg__cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.57 813.45c.1-.65-.46-1.17-1.19-2.08a40.75 40.75 0 01-2.22-3.56c-1.07-1.8-.47-3.33 0-8.16.13-1.38.24-4.43.44-10.53.13-3.86.2-5.79.15-6.38a25.45 25.45 0 00-5.34-13.06 29.59 29.59 0 00-12.32-9.5 32.22 32.22 0 00-14.83-2.08 30.51 30.51 0 00-10.09 1.9 28 28 0 00-13.95 11.87 28.93 28.93 0 00-3.56 15.44 76.66 76.66 0 001.48 9.49c.95 4.4 1.75 6.35 1 9.35-.39 1.62-1 4.09-3 5.19-1 .58-2.21.63-2.52 1.49a2.23 2.23 0 00.74 2.22 2.62 2.62 0 001.49.6c3.58.36 7 1.69 10.53 2.37 3.3.64 2.64.73 5.79 1.34a81 81 0 009.35 1.18 69.11 69.11 0 0016.76-.44c4.79-.77 3.77-1.27 8.76-2.08a65 65 0 0010.38-3c.66-.15 2.01-.65 2.15-1.57z",
    className: "speedlimit20_before_svg__cls-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459 791.19a5.6 5.6 0 00-2.52 1.49 6.26 6.26 0 00-1.49 4.89 6.32 6.32 0 001.34 3.57 6 6 0 002.82 1.92",
    className: "speedlimit20_before_svg__cls-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.49 770c-.89.62-7.07 4.73-9 9.5a20.43 20.43 0 00-1.34 5.64v2.37c.06 2.79.12 5.7.45 9.65.15 1.76.22 2.63.3 3.11a23.54 23.54 0 004.45 10.24 20.94 20.94 0 008.75 7.13 20.24 20.24 0 0010.83 1.33 21.22 21.22 0 0012.17-6.68 27 27 0 005.9-10.56c3.88-12 .6-23.56-1.19-28.64",
    className: "speedlimit20_before_svg__cls-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.64 766.86a38.33 38.33 0 006.38 2.67 44.49 44.49 0 009.2 1.78c4.3.47 4.95.11 10.24.59 4.48.41 6.74.64 8 1.64 3 2.4 2.75 7.79 2.67 10.53 0 .65-.14 3.45-.3 6.53a11.82 11.82 0 00.15 3.86c.44 1.7 1.22 2.44 2.52 4.3 2.86 4.09 3.2 6.36 4 6.23.18 0 1-.27 1.33-5.49a62 62 0 00-.44-12c-1-9.5-1.58-11.68-3.26-13.94a14.87 14.87 0 00-3-3",
    className: "speedlimit20_before_svg__cls-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.48 821.56v2l-19-1a3.52 3.52 0 00-2.09 0 4 4 0 00-2.52 3.27l7.13 1.77 11.37 3.16s18.6 1.39 18.9 1.29 19.73-5.24 19.73-5.24a5.88 5.88 0 00-.49-2.38 2.63 2.63 0 00-1.29-1.58 1.93 1.93 0 00-1.29 0l-20.47.29.1-2.26",
    className: "speedlimit20_before_svg__cls-9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343a51",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 1.74,
    d: "M453.59 825c2 .43 4.89 1 8.46 1.71 7.94 1.48 11.91 2.22 16.1 2.37 4.8.17 8.24-.32 14.91-1.26 7-1 11.36-1.11 13.13-2.45a2.11 2.11 0 011.56-.52c.95.17 1.56 1.35 1.93 2.38l-.67 4.87-.3 8-5.9 19.73h-45.36l-5.62-21.07-.32-12.28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.87 835.51c-.27 1.58-.51 3.27-.7 5.07s-.33 3.9-.39 6a79.72 79.72 0 00.69 13h6c-.18-.87-.34-1.76-.49-2.67a68.42 68.42 0 01-.69-16.42l-4.75.49M457.87 840.86l-5.44-1.29a56 56 0 01.29 7.32 54.87 54.87 0 01-1.78 12.56h6.14a69.28 69.28 0 001-15.93 70 70 0 00-1.09-9M505.32 794.61c.25.54 0-.85 0 .34 0 1.75-.12 5.36-.46 5.89",
    className: "speedlimit20_before_svg__cls-9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 466.07,
    x2: 466.24,
    y1: 788.52,
    y2: 789.95,
    className: "speedlimit20_before_svg__cls-11"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 468.67,
    x2: 468.44,
    y1: 788.35,
    y2: 789.54,
    className: "speedlimit20_before_svg__cls-11"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 470.75,
    x2: 469.63,
    y1: 788.67,
    y2: 789.95,
    className: "speedlimit20_before_svg__cls-11"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 472.06,
    x2: 470.58,
    y1: 789.95,
    y2: 790.77,
    className: "speedlimit20_before_svg__cls-11"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 463.88,
    x2: 464.79,
    y1: 789.35,
    y2: 790.31,
    className: "speedlimit20_before_svg__cls-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.59 790.62c0-.39 1.46-1.12 3-1.17 1 0 1.79.36 3.36 1.15.06 0 .17.09.18.18 0 .33-1.08.75-1.82.93a5.38 5.38 0 01-2.11.15 8 8 0 01-2.38-1.06c-.12-.04-.22-.1-.23-.18z",
    className: "speedlimit20_before_svg__cls-12"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466.83,
    cy: 790.67,
    r: 1.03,
    className: "speedlimit20_before_svg__cls-13"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 493.12,
    x2: 492.95,
    y1: 788.51,
    y2: 789.94,
    className: "speedlimit20_before_svg__cls-11"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 490.52,
    x2: 490.75,
    y1: 788.35,
    y2: 789.53,
    className: "speedlimit20_before_svg__cls-11"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 488.44,
    x2: 489.56,
    y1: 788.66,
    y2: 789.94,
    className: "speedlimit20_before_svg__cls-11"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 487.13,
    x2: 488.61,
    y1: 789.94,
    y2: 790.76,
    className: "speedlimit20_before_svg__cls-11"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 495.3,
    x2: 494.4,
    y1: 789.35,
    y2: 790.3,
    className: "speedlimit20_before_svg__cls-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.6 790.61c0-.38-1.46-1.11-3-1.17-1 0-1.79.36-3.36 1.15-.06 0-.17.09-.18.19 0 .32 1.08.74 1.82.92a5 5 0 002.11.15 7.85 7.85 0 002.37-1.06c.13-.04.23-.09.24-.18z",
    className: "speedlimit20_before_svg__cls-12"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 490.63,
    cy: 790.77,
    r: 1.03,
    className: "speedlimit20_before_svg__cls-13"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 467.49,
    cy: 797.4,
    r: 3.15,
    className: "speedlimit20_before_svg__cls-14"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 491.33,
    cy: 797.4,
    r: 3.15,
    className: "speedlimit20_before_svg__cls-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.38 797.92a12.9 12.9 0 01-.15 1.88 4.22 4.22 0 00-.05 1.83 1.74 1.74 0 00.35.74c.5.54 1.59.51 2.72 0M464 784.09a6.44 6.44 0 012.37-1.29 5.59 5.59 0 013.37 0 5.2 5.2 0 011.53.79M488.77 784a7.85 7.85 0 012.52-.7 8 8 0 013.86.6",
    className: "speedlimit20_before_svg__cls-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.59 809.65a16.9 16.9 0 002.62.1 39.18 39.18 0 004.06-.25c2.24-.28 2.36-.54 2.37-.64.06-.34-.72-.73-1.33-1a7.27 7.27 0 00-3.12-.89 8.39 8.39 0 00-3.41.79c-.56.21-2.82 1-2.72 1.54.04.18.59.25 1.53.35z",
    className: "speedlimit20_before_svg__cls-16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.53 807.78a7.44 7.44 0 012.22.64l1 .19a7.72 7.72 0 00-3.56-2.07 7.22 7.22 0 00-3.22-.1 5.75 5.75 0 00-2.91 1.43 5.14 5.14 0 00-1 1.39l.42-.19.91-.41.65-.14c2.7-.61 4.07-.91 5.49-.74z",
    className: "speedlimit20_before_svg__cls-17"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.3,
    height: 22.73,
    x: 490.73,
    y: 814.78,
    className: "speedlimit20_before_svg__cls-18",
    transform: "rotate(-29.97 492.987 826.247)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 22.73,
    height: 4.3,
    x: 500.36,
    y: 823.99,
    className: "speedlimit20_before_svg__cls-18",
    transform: "rotate(-60.02 511.752 826.161)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.94 872.84a32.54 32.54 0 1132.54-32.54 32.58 32.58 0 01-32.54 32.54zm0-58.62A26.08 26.08 0 10529 840.3a26.11 26.11 0 00-26.06-26.08z",
    className: "speedlimit20_before_svg__cls-18"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 65.4,
    height: 44.19,
    x: 257.48,
    y: 980.63,
    className: "speedlimit20_before_svg__cls-19",
    rx: 8.61
  }), /*#__PURE__*/React.createElement("rect", {
    width: 65.4,
    height: 44.19,
    x: 545.99,
    y: 980.63,
    className: "speedlimit20_before_svg__cls-19",
    rx: 8.61
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.42 827.66c-2.48-4.44-6.16-6.56-9.28-8.3 0 0-10.17-5.69-30-2a5.41 5.41 0 00-2.69 1.22c-2.85 2.6-1.46 8.3-1.22 9.29 1.64 6.69 7.09 10.62 11 13.43a39.06 39.06 0 0011.43 5.7c3.22 1 6.16 1.84 10 1.46 2.44-.24 8.63-.84 11.72-5.61 3.94-6.09-.26-13.94-.96-15.19zM554.67 829.76c2.48-4.44 6.16-6.56 9.28-8.3 0 0 10.17-5.69 30-2a5.23 5.23 0 012.69 1.22c2.85 2.59 1.46 8.3 1.22 9.28-1.63 6.69-7.09 10.62-11 13.43a39.06 39.06 0 01-11.48 5.62c-3.21 1-6.16 1.84-10 1.46-2.44-.23-8.63-.84-11.72-5.61-3.89-6 .34-13.86 1.01-15.1z",
    className: "speedlimit20_before_svg__cls-20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce2232",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2.15,
    d: "M561.1 841.76c0-4-58.05-7.34-129.65-7.34s-129.64 3.29-129.64 7.34l-54.23 31.94 370.8 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.6 874.05C603 864.4 525.11 857 431 857c-99.34 0-180.64 8.25-187.23 18.69a19.57 19.57 0 00-8.64 16.31v50h.06c2.57 9.71 89.56 17.51 196.5 17.51s193.92-7.8 196.49-17.51h.07v-50a19.6 19.6 0 00-11.65-17.95z",
    className: "speedlimit20_before_svg__cls-7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 430.04,
    x2: 430.03,
    y1: 752.46,
    y2: 770.96,
    fill: "none",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 5.74
  }), /*#__PURE__*/React.createElement("rect", {
    width: 157.91,
    height: 62.29,
    x: 350.54,
    y: 911.92,
    fill: "#7d7e82",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2.15,
    rx: 8.61
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a8a9ad",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2.15,
    d: "M631.56 942.52a8.61 8.61 0 00-3.31-6.77V942h-.07c-2.57 9.71-89.56 17.51-196.49 17.51s-193.93-7.8-196.5-17.51h-.06v-6.18a8.58 8.58 0 00-3.27 6.73v30a8.65 8.65 0 00.25 2.05 2.51 2.51 0 00-.25 1.09c0 11.82 89.47 21.41 199.85 21.41s199.85-9.59 199.85-21.41a2.53 2.53 0 00-.26-1.09 8.66 8.66 0 00.26-2.05z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 50.93,
    height: 13.56,
    x: 404.57,
    y: 764.18,
    className: "speedlimit20_before_svg__cls-18",
    rx: 4.99
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.12 833.23 555.85 836.85 549.06 795.32 523.98 768.16 503.24 754.23 455.05 750.65 361.21 755.51 337.14 771.82 316.29 801.64 310.12 833.23",
    className: "speedlimit20_before_svg__cls-25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.82 749.62h-84.41a85.19 85.19 0 00-85.19 85.19v5.54H559v-5.54a85.19 85.19 0 00-85.18-85.19zM549.35 833H314.06v-1.63a75.46 75.46 0 0175.46-75.45h84.38a75.45 75.45 0 0175.45 75.45z",
    className: "speedlimit20_before_svg__cls-7"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 151.68,
    height: 2.69,
    x: 354.21,
    y: 921.84,
    className: "speedlimit20_before_svg__cls-26",
    rx: 1.34
  }), /*#__PURE__*/React.createElement("rect", {
    width: 151.68,
    height: 2.69,
    x: 354.19,
    y: 927.4,
    className: "speedlimit20_before_svg__cls-26",
    rx: 1.34
  }), /*#__PURE__*/React.createElement("rect", {
    width: 151.68,
    height: 2.69,
    x: 354.21,
    y: 932.96,
    className: "speedlimit20_before_svg__cls-26",
    rx: 1.34
  }), /*#__PURE__*/React.createElement("rect", {
    width: 151.68,
    height: 2.69,
    x: 354.2,
    y: 938.51,
    className: "speedlimit20_before_svg__cls-26",
    rx: 1.34
  }), /*#__PURE__*/React.createElement("rect", {
    width: 151.68,
    height: 2.69,
    x: 354.22,
    y: 944.07,
    className: "speedlimit20_before_svg__cls-26",
    rx: 1.34
  }), /*#__PURE__*/React.createElement("rect", {
    width: 151.68,
    height: 2.69,
    x: 354.21,
    y: 949.63,
    className: "speedlimit20_before_svg__cls-26",
    rx: 1.34
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.18,
    height: 26.52,
    x: 241,
    y: 883.12,
    className: "speedlimit20_before_svg__cls-27",
    rx: 8.61
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.18,
    height: 26.52,
    x: 571.92,
    y: 882.78,
    className: "speedlimit20_before_svg__cls-27",
    rx: 8.61
  })), /*#__PURE__*/React.createElement("g", {
    id: "speedlimit20_before_svg__Haus_rechts"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#d9d9d9",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    points: "1259.38 967.1 1080.61 967.1 1080.61 735.51 1260.34 735.51 1259.38 967.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1260.66 591.84 1174.91 591.84 1080.51 735.67 1260.34 735.67 1260.66 591.84",
    className: "speedlimit20_before_svg__cls-29"
  }), /*#__PURE__*/React.createElement("g", {
    id: "speedlimit20_before_svg__Fenster"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86.28,
    height: 86.28,
    x: 1175.32,
    y: 768.72,
    className: "speedlimit20_before_svg__cls-30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170.21 763.62v96.49h96.5v-96.49zm5.11 5.1H1215v40.89h-39.71zm0 86.28v-40.89H1215V855zm86.28 0h-42.07v-40.89h42.07zm0-45.39h-42.07v-40.89h42.07z",
    className: "speedlimit20_before_svg__cls-29"
  })), /*#__PURE__*/React.createElement("g", {
    id: "speedlimit20_before_svg__Fenster-2",
    "data-name": "Fenster"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86.28,
    height: 86.28,
    x: 1175.32,
    y: 862.13,
    className: "speedlimit20_before_svg__cls-30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170.21 857v96.49h96.5V857zm5.11 5.1H1215V903h-39.71zm0 86.28v-40.86H1215v40.89zm86.28 0h-42.07v-40.86h42.07zm0-45.39h-42.07v-40.86h42.07z",
    className: "speedlimit20_before_svg__cls-29"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 89.53,
    height: 153.6,
    x: 991.08,
    y: 813.39,
    fill: "#d9d9d9",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "991.08 813.39 1078.67 813.39 1080.61 757.96 1080.28 757.96 991.08 813.39",
    className: "speedlimit20_before_svg__cls-29"
  }), /*#__PURE__*/React.createElement("g", {
    id: "speedlimit20_before_svg__Fenster-3",
    "data-name": "Fenster"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54.23,
    height: 54.23,
    x: 1008.73,
    y: 833,
    className: "speedlimit20_before_svg__cls-30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.52 829.79v60.65h60.65v-60.65zm3.21 3.21h25v25.7h-25zm0 54.23v-25.7h25v25.7zm54.23 0h-26.44v-25.7H1063zm0-28.53h-26.44V833H1063z",
    className: "speedlimit20_before_svg__cls-29"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "speedlimit20_before_svg__Haus_links"
  }, /*#__PURE__*/React.createElement("g", {
    id: "speedlimit20_before_svg__Fasade",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 461.72,
    height: 299.95,
    x: -217.37,
    y: 669.23,
    fill: "#f2ab80",
    transform: "rotate(-180 13.495 819.205)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 461.72,
    height: 84.34,
    x: -217.37,
    y: 884.84,
    fill: "#ca9072",
    transform: "rotate(-180 13.495 927.01)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "speedlimit20_before_svg__Tuer",
    d: "M-31.71 791.9h97.78v128.2A48.86 48.86 0 0117.21 969h-.06a48.86 48.86 0 01-48.86-48.9V791.9z",
    className: "speedlimit20_before_svg__cls-34",
    transform: "rotate(180 17.18 880.43)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 126.61,
    height: 20.25,
    x: -45.99,
    y: 948.93,
    fill: "#9a9a9a",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    transform: "rotate(-180 17.32 959.055)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "speedlimit20_before_svg__Fenster-4",
    "data-name": "Fenster"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64.76,
    height: 77.06,
    x: 95.67,
    y: 733.84,
    fill: "#7fc3ca",
    transform: "rotate(-180 128.045 772.365)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "speedlimit20_before_svg__Schatten"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "131.21 768.13 130.45 768.13 130.45 733.84 130.45 733.84 131.21 739.25 131.21 768.13",
    className: "speedlimit20_before_svg__cls-37"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.94 768.13 95.67 768.13 95.67 733.84 95.67 733.84 97.94 741.05 97.94 768.13",
    className: "speedlimit20_before_svg__cls-37"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.67 733.84 97.94 741.05 125.64 741.05 125.64 733.73 95.67 733.84 95.67 733.84",
    className: "speedlimit20_before_svg__cls-37"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.94 810.9 95.67 810.9 95.67 776.61 95.67 776.61 97.94 781.92 97.94 810.9",
    className: "speedlimit20_before_svg__cls-37"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.67 776.61 97.94 781.92 125.64 781.92 125.64 776.53 95.67 776.61 95.67 776.61",
    className: "speedlimit20_before_svg__cls-37"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.2 810.9 130.45 810.9 130.45 776.61 130.45 776.61 131.2 780.52 131.2 810.9",
    className: "speedlimit20_before_svg__cls-37"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.45 776.61 131.2 780.52 160.43 780.4 160.43 776.53 130.45 776.61 130.45 776.61",
    className: "speedlimit20_before_svg__cls-37"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.45 733.84 131.21 739.25 160.43 739.25 160.43 733.73 130.45 733.84 130.45 733.84",
    className: "speedlimit20_before_svg__cls-37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.86 819.35l4.81 3.9 67-.11c.93 0 1.61-1.52 2-3l.46-4-74.25 3.21z",
    className: "speedlimit20_before_svg__cls-37"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M165.21 733.84v-5.26a3.22 3.22 0 00-3.23-3.22H94.11a3.23 3.23 0 00-3.23 3.22V816.15a3.23 3.23 0 003.22 3.23H162a3.23 3.23 0 003.23-3.23v-5.25h.05v-77.06zm-4.78 34.29h-30v-34.29h30zm-34.79-34.29v34.29h-30v-34.29zm-30 42.77h30v34.29h-30zm34.78 34.29v-34.29h30v34.29z",
    className: "speedlimit20_before_svg__cls-34"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#555",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    points: "-230.53 673.41 16.23 480.8 258.82 673.41 -230.53 673.41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "speedlimit20_before_svg__Frau"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.94 905.52c-1 .2-2.57.53-4.42 1-5.13 1.34-6.43 2.25-7.49 1.53-1.27-.85-.77-3-.68-7.49.06-3.24-.41-6.47-.51-9.7-.31-9.22-2-17.76-2.56-23.49-.62-6.72-.28-16.63 4.6-29.62l8.17-12.41s7.32-.5 7.83 0c2.65 2.58 3.21 6.76 3.23 9.86.14 17.42.21 26.14-2.89 41.19-.45 2.17-1.7 8.05-3.58 17.36-.5 2.51-.91 4.57-1.19 6zM260.05 951.37a81.67 81.67 0 01-1.53-9.68 42.37 42.37 0 01.25-9.71c2.69-19.87 2.62-58.14-.51-84-.64-5.27-1.81-13.36-7.4-16.08-3.17-1.54-7.72-1.35-10.47 1s-2.62 5.78-1.53 21.7c.58 8.6 1.33 18.52 1.53 21.45.55 8.09.56 8.86 1 15.83 2 29.9 3.22 38.92 4.09 44.42.77 5 .41 14.69.9 17.19",
    className: "speedlimit20_before_svg__cls-39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.21 922c3.23-8.15 3.78-10.18 7-18.33 2.89-.17 10.77.17 13.66 0L198 923",
    className: "speedlimit20_before_svg__cls-40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.62 926.45A9.88 9.88 0 00198 923c-.49-6.11-7.06-12.38-14.07-12a13.59 13.59 0 00-8.58 4.12 16.5 16.5 0 00-4.81 11zM267.47 970.57c-3.23-8.15-3.78-10.17-7-18.32-2.89-.17-10.77.17-13.66 0l-6.08 19.37",
    className: "speedlimit20_before_svg__cls-40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.06 975.05a9.85 9.85 0 01-.34-3.43c.49-6.1 7.06-12.37 14.07-12a13.59 13.59 0 018.58 4.12 16.51 16.51 0 014.81 11z",
    className: "speedlimit20_before_svg__cls-40"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#54525c",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M259 793.86l-1.36 52.59a24.61 24.61 0 00-14.64 1.41 22.59 22.59 0 00-4.09 2.34c-1.35-11.71-2.89-20.73-4.08-26.9a16.73 16.73 0 00-2.39-6.46c-3.78-5.82-12.44-10.23-19.74-7.49-4.95 1.86-7.53 6.36-8.17 7.49-.84 1.46-1.53 3.84-2.89 8.52-.39 1.36-2.06 7.13-2.56 8.84-5-3.72-10.8-4.74-14.86-2.39a9.47 9.47 0 00-3.18 3.07c1.59-11.69 4.88-26.78 6.47-38.47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.07 769.64a24.49 24.49 0 01-1 7l-11.91 1.23q-5.1-23.54-10.9-47.66-2.17-9.07-4.42-18l14-1a25.54 25.54 0 012.35 3.58s.24.46.58 1.17c0 0 .62 1.33 1.12 2.75 1.39 3.94 6.13 29.27 6.13 29.27 1.37 7.34 2.06 11 2.38 12.26.85 3.24 1.68 5.76 1.67 9.4zM184.78 714.67c-5 18.92-9.41 35.55-15.69 55-.75 2.33-1.5 4.64-2.27 7l-3.17-4-10.24-1.48a324.85 324.85 0 017.51-31.91c2.55-8.8 6.28-17 9.13-24.51z",
    className: "speedlimit20_before_svg__cls-42"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.11 626.8 180.11 692.5 259.25 691.47 259.87 626.8 180.11 626.8",
    className: "speedlimit20_before_svg__cls-43"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffdccd",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.61,
    d: "M195.44 693.27a14.88 14.88 0 01-1.63-4h17.9V672h17.17v17.76h15.39a11.58 11.58 0 010 4.73c-1.18 5.41-6.25 8.32-9 9.92a23 23 0 01-8.73 3.1c-4.93.64-10-1.65-20.12-6.21-5.73-2.61-8.87-4.44-10.98-8.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343a50",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M200.17 695c11.44 6.87 15 10.62 22.2 11a25.43 25.43 0 005-.29 32.76 32.76 0 0015.39-7.11c6.74-5.43 6.11-8.8 11.24-10.35a12.84 12.84 0 019.18.59 10.53 10.53 0 014.73 4.44 11.16 11.16 0 011.19 5c.08 1.71 2.65 1 1.9 4.29-.47 2.09 3.45 7.06 2.75 9.87l-15.45-.55v15.71l2.37 66.26-73.16 2.55L186 712.5l-16 2.68c0-.81.06-5 0-6.5-.27-6.91 1.81-9.08 2.32-13 .23-1.79.65-5.3 3.26-7.1 2.22-1.53 5-1.12 7.4-.59a57.17 57.17 0 0117.19 7.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#46bea9",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M187.59 692.1a47.35 47.35 0 00-1.77-5.2H208l-1.39 109.51h-19.07l-2.76-77a15.6 15.6 0 001.48-1.78c6.03-8.63 2.24-22.26 1.33-25.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6784b3",
    stroke: "#343a50",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M257 718a12.81 12.81 0 001.34 1.33l2.37 74.55-22.75.79-2.57-107.77h22.05c-.14.43-.5 1.5-.89 2.87-2.03 7.06-5.96 20.73.45 28.23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.46 650.63c-1.2-.17-5.29-.65-7.4-2.22-.75-.57-5.28-3.95-4.58-9 .48-3.53 5.87-6.52 9.67-7.55M254.83 632.87c.93 0 5.24-.82 7 .44 2.84 2.09 2.92 5.77 3 7.4s.12 5.71-3.11 8.29c-2.25 1.79-7.85 1.82-8.76 1.78",
    className: "speedlimit20_before_svg__cls-48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.49 636.72a3.3 3.3 0 012.66.44c1.23.94 1.56 3.05.45 4.88M180.11 638.64a4.18 4.18 0 013.41.59c1.51 1.25 1.77 4.13 0 6.51",
    className: "speedlimit20_before_svg__cls-49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.44 626.21a54.91 54.91 0 000 13.35c.49 4 1.43 11.92 6.22 19.37 1.5 2.34 11.32 17 28.41 17.22 12.3.16 20.65-7.27 22.64-9 10.6-9.44 11.63-22.28 12-26.69a44.24 44.24 0 00-.88-12.92c-.95-4.35-1.53-7-3.41-9.13-3.46-3.94-8.63-3.06-18.35-3.55-18.32-.93-19.2-5.05-28.7-2.67-2.73.69-11.64 2.92-15.69 10.36a16.79 16.79 0 00-.89 1.92z",
    className: "speedlimit20_before_svg__cls-48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.2 622.36a67.52 67.52 0 010 7.85 92.45 92.45 0 00-10.8-4.59c-4-1.4-7-2.18-10.06-3-7.68-1.95-11.51-2.93-16.28-3.26a62.26 62.26 0 00-16 1.19A91.46 91.46 0 00191.8 625a95.89 95.89 0 00-11.8 5.35 40 40 0 01-1-7.4c-.14-3-.68-14.69 6.95-24.41 2.73-3.47 5.43-5.33 8.88-7.7 4.31-3 11-7.44 20.87-8.58a40.31 40.31 0 0133.74 12.14 37 37 0 019.76 14.79 48.83 48.83 0 012 13.17z",
    className: "speedlimit20_before_svg__cls-43"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.69,
    cy: 633.14,
    r: 5.14,
    className: "speedlimit20_before_svg__cls-12"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.04,
    cy: 634.44,
    r: 2.7,
    className: "speedlimit20_before_svg__cls-13"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 239.01,
    cy: 633.44,
    r: 5.14,
    className: "speedlimit20_before_svg__cls-12"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240.36,
    cy: 634.74,
    r: 2.7,
    className: "speedlimit20_before_svg__cls-13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#343a51",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M218.26 646.9a35.16 35.16 0 00-.44 4.22c-.08 1.73 0 2.35.44 2.89a3.65 3.65 0 001.89 1.11 3.59 3.59 0 001.33.11c.26 0 1.89-.23 2.11-1.22a2 2 0 00-1.45-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#343a51",
    strokeMiterlimit: 10,
    strokeWidth: 0.87,
    d: "M220.29 655.64a1.47 1.47 0 00.45.92 1.48 1.48 0 002.44-1.37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.29 625.82a10.5 10.5 0 014.44-2.22 10.87 10.87 0 017.32 1M234.91 625.82a9.46 9.46 0 013.55-1.56 10.2 10.2 0 017.43 1.56",
    className: "speedlimit20_before_svg__cls-52"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 197.28,
    x2: 197.28,
    y1: 608.88,
    y2: 621.9,
    className: "speedlimit20_before_svg__cls-53"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 212.96,
    x2: 212.22,
    y1: 597.78,
    y2: 618.35,
    className: "speedlimit20_before_svg__cls-53"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 236.34,
    x2: 236.34,
    y1: 605.62,
    y2: 620.86,
    className: "speedlimit20_before_svg__cls-53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.17 661.8a12.07 12.07 0 012.26 1.31l-8.14.32h-9.23c.34-.19.92-.49 1.67-.82 1.61-.69 7.72-3.34 13.44-.81z",
    className: "speedlimit20_before_svg__cls-16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.66 664.1a10.13 10.13 0 00.77-.67l-17.37.22a12.25 12.25 0 001 .86c4.39 3.15 11.51 2.85 15.6-.41z",
    className: "speedlimit20_before_svg__cls-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.36 977.38h-.06a3 3 0 01-2.94-3l.28-16.39-15.28-.68a3 3 0 11.26-6l18.21.8a3 3 0 012.86 3l-.33 19.31a3 3 0 01-3 2.96zM202.45 957.32h-.13l-18.2-.8a3 3 0 01-2.87-3l.34-19.31a3 3 0 013-2.95h.06a3 3 0 013 3l-.29 16.39 15.29.68a3 3 0 01-.14 6z",
    className: "speedlimit20_before_svg__cls-54"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.37,
    height: 5.89,
    x: 209.41,
    y: 951.37,
    className: "speedlimit20_before_svg__cls-55"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.37,
    height: 5.89,
    x: 226.32,
    y: 951.37,
    className: "speedlimit20_before_svg__cls-55"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.68,
    height: 165.59,
    x: 211.64,
    y: 870.71,
    fill: "#455064",
    stroke: "#2c3d4f",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    rx: 7.83
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.45,
    height: 6.06,
    x: 175.02,
    y: 928.14,
    className: "speedlimit20_before_svg__cls-57",
    rx: 3.03
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.45,
    height: 6.06,
    x: 245.21,
    y: 977.24,
    className: "speedlimit20_before_svg__cls-57",
    rx: 3.03
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.18,
    height: 14.73,
    x: 205.04,
    y: 852.66,
    className: "speedlimit20_before_svg__cls-58"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.18,
    height: 14.73,
    x: 229.27,
    y: 852.66,
    className: "speedlimit20_before_svg__cls-58"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ea384e",
    stroke: "#2c3d4f",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M229.77 864.44h-21.14a6.18 6.18 0 00-6.18 6.18v86.17a3.71 3.71 0 003.71 3.7h0a3.7 3.7 0 003.7-3.7v-86a24 24 0 0118.67-.55v86.56a3.71 3.71 0 007.41 0v-86.18a6.18 6.18 0 00-6.17-6.18z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.37,
    height: 27.27,
    x: 201.67,
    y: 941.02,
    className: "speedlimit20_before_svg__cls-57",
    rx: 2.18
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.37,
    height: 27.27,
    x: 234.3,
    y: 941.02,
    className: "speedlimit20_before_svg__cls-57",
    rx: 2.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.94 849.62a2.94 2.94 0 00-2-.85 24.82 24.82 0 01-6.7-2.09c-.43-.18-2.25-.95-3.66-1.67v-3.7h-8.71V845c-1.41.72-3.23 1.49-3.66 1.67a24.82 24.82 0 01-6.7 2.09 2.94 2.94 0 00-2 .85 3 3 0 00-.33 2.57 3.32 3.32 0 001.47 1.95c.9.49 1.75.28 5-.43l3-.67a39.16 39.16 0 016.08-.95h3.01a39.16 39.16 0 016.08.95l3 .67c3.24.71 4.1.92 5 .43a3.32 3.32 0 001.47-1.95 3 3 0 00-.35-2.56z",
    className: "speedlimit20_before_svg__cls-60"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ea384e",
    stroke: "#2c3d4f",
    strokeMiterlimit: 10,
    strokeWidth: 1.67,
    d: "M212.91 824.9h12.58v15.92a1.61 1.61 0 01-1.61 1.61h-9.35a1.61 1.61 0 01-1.61-1.61V824.9h-.01z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.63,
    height: 13.36,
    x: 208.33,
    y: 812,
    className: "speedlimit20_before_svg__cls-60",
    rx: 3.88
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.67,
    height: 10.76,
    x: 209.31,
    y: 813.3,
    fill: "#aec2dd",
    stroke: "#2c3d4f",
    strokeMiterlimit: 10,
    strokeWidth: 1.67,
    rx: 3.32
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2d3e50",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 1.67,
    d: "M219.1 788.3h0a4 4 0 014 4v20.43h0-8.08 0v-20.4a4 4 0 014.08-4.03z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.73 788.3h-21.52a3.31 3.31 0 010-6.61h21.52a3.31 3.31 0 010 6.61z",
    className: "speedlimit20_before_svg__cls-64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.75 784.83a67.51 67.51 0 0015.68.19c6.47-.69 10-2.06 12.73.19 2.44 2 1.92 4.94 5.41 7.22a12.06 12.06 0 004.56 1.61 28.56 28.56 0 0011.12.1",
    className: "speedlimit20_before_svg__cls-65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.05 788.3h21.52a3.31 3.31 0 000-6.61h-21.52a3.31 3.31 0 000 6.61z",
    className: "speedlimit20_before_svg__cls-64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271 784.83a67.43 67.43 0 01-15.67.19c-6.47-.69-10-2.06-12.73.19-2.45 2-1.92 4.94-5.42 7.22a12.06 12.06 0 01-4.56 1.61 28.5 28.5 0 01-11.11.1",
    className: "speedlimit20_before_svg__cls-65"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.22,
    cy: 780.9,
    r: 10.53,
    className: "speedlimit20_before_svg__cls-39"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.13,
    cy: 781.69,
    r: 10.53,
    className: "speedlimit20_before_svg__cls-39",
    transform: "rotate(-22.5 282.13 781.706)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "speedlimit20_before_svg__Baum"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1083.86,
    cy: 755.77,
    r: 77.79,
    fill: "#89bb21",
    stroke: "#343a50",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.87 757.26a77.78 77.78 0 0177.78-77.79c1.78 0 3.55.07 5.29.19a77.79 77.79 0 10-21.37 153.72 77.82 77.82 0 01-61.7-76.12z",
    className: "speedlimit20_before_svg__cls-37"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6b472d",
    d: "M1073.49 984.26a4.62 4.62 0 01-3.32-1.42 4.37 4.37 0 01-1.22-3.26l12.4-180.58-13.84-13.87a1.94 1.94 0 01-.43-2.13 2 2 0 012.67-1l12.35 6 1.78-25.92.11-2.14a4.39 4.39 0 018.76-.16l1.16 15.82 12.34-6.53h.24a2.44 2.44 0 01.53 0 2.94 2.94 0 012.76 2 2.9 2.9 0 01-1 3.26l-13.56 9.67 12.45 195.44a4.37 4.37 0 01-1.15 3.33 4.58 4.58 0 01-3.38 1.48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088.38 757.26a2.78 2.78 0 012.87 2.63l1.33 18.09 14.17-7.5h.27a1.44 1.44 0 01.84 2.58l-14.19 10.24 12.5 196.26a3 3 0 01-3 3.22h-29.65a3 3 0 01-3-3.11l12.44-181.21-14.32-14.35a.46.46 0 01.32-.79.46.46 0 01.21.05l14.35 6.94 1.93-28.13.11-2.16a2.8 2.8 0 012.89-2.74m0-3a5.81 5.81 0 00-5.88 5.58l-.12 2.14-1.62 23.68-10.36-5a3.46 3.46 0 00-4 5.56l13.36 13.39-12.34 179.85a5.83 5.83 0 001.62 4.37 6.11 6.11 0 004.41 1.89h29.65a6.11 6.11 0 004.49-2 5.94 5.94 0 001.54-4.47l-12.4-194.57 12.85-9.28a4.37 4.37 0 001.52-4.93 4.42 4.42 0 00-4.18-3 4.22 4.22 0 00-.79.07l-.47.08-.42.22-10.1 5.35-1-13.51a5.8 5.8 0 00-5.87-5.41z",
    className: "speedlimit20_before_svg__cls-4"
  }), /*#__PURE__*/React.createElement("g", {
    className: "speedlimit20_before_svg__cls-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1092.69 779.47l15.57-8.24a1.39 1.39 0 00-1.51-.75l-14.17 7.5zM1086.29 791.67l2-29.51.11-2.16a2.75 2.75 0 011.43-2.37 2.9 2.9 0 00-4.36 2.37l-.11 2.16-1.92 28.13zM1073.38 979.65l12.44-181.21-13.51-13.54-3.21-1.55a.46.46 0 00-.53.74l14.32 14.35-12.44 181.21a3 3 0 003 3.11h2.93a3 3 0 01-3-3.11z",
    className: "speedlimit20_before_svg__cls-69"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "speedlimit20_before_svg__Busch"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#89bb21",
    d: "M-114.58 1031.36h-2c-11.3 0-20.5-5.79-20.5-12.9 0-5.95 6.39-11 15.4-12.49-2.59-2.21-4-4.89-4-7.67 0-5.88 6.16-10.92 15.09-12.44a8.11 8.11 0 01-.49-2.75c0-6.34 7.1-11.63 17-12.7.36-6.91 9.41-12.47 20.48-12.47a32.63 32.63 0 015.72.5c3.8-3.61 10.15-5.76 17.07-5.76a29.88 29.88 0 0111.16 2.07c3.52-3.21 9.24-5.26 15.46-5.53 3.79-3.69 10.19-5.89 17.2-5.89 11.15 0 20.25 5.63 20.49 12.61 7.18 1.07 13 4.54 15 9h.17c10 0 18.34 4.39 20.13 10.52 9.95.07 18.21 4.5 19.9 10.64 8.26 1.8 13.77 6.66 13.77 12.19 0 3.2-1.81 6.19-5.12 8.55 7.06 2.14 11.55 6.6 11.55 11.61 0 5.86-6.29 11-15.29 12.47l-187.16.42c-.36.01-.7.02-1.03.02z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7 943.92c11 0 19.87 5.5 19.87 12.27a2.06 2.06 0 010 .26c7.5 1 13.42 4.54 15.22 9.11h.58c10 0 18.27 4.58 19.64 10.53h.23c10 0 18.29 4.59 19.64 10.55 7.93 1.61 13.66 6.22 13.66 11.65 0 3.45-2.31 6.56-6 8.78 7.29 1.82 12.44 6.23 12.44 11.38 0 5.68-6.27 10.45-14.76 11.84l-187.11.43h-3c-11 0-19.87-5.5-19.87-12.27 0-6 7.06-11 16.36-12.07-3.08-2.16-5-5-5-8.09 0-5.81 6.55-10.67 15.33-11.94a8 8 0 01-.73-3.25c0-6.16 7.37-11.25 17-12.12v-.15c0-6.78 8.89-12.27 19.86-12.27a30.5 30.5 0 015.92.56c3.51-3.49 9.74-5.82 16.87-5.82a28.85 28.85 0 0111.3 2.19c3.33-3.23 9-5.42 15.59-5.66 3.49-3.52 9.76-5.88 16.93-5.88m0-1.26c-7.06 0-13.54 2.2-17.47 5.9-6.09.31-11.72 2.31-15.31 5.42a30.72 30.72 0 00-11-2c-6.94 0-13.33 2.12-17.27 5.72a32.38 32.38 0 00-5.52-.46c-11.13 0-20.27 5.54-21.07 12.54-9.92 1.23-17 6.7-17 13.26a8.83 8.83 0 00.3 2.26c-8.85 1.71-14.91 6.9-14.91 12.93a10.33 10.33 0 003.28 7.27c-8.65 1.76-14.67 6.91-14.67 12.89 0 7.46 9.48 13.53 21.13 13.53h3l187.05-.42h.2c9.32-1.53 15.82-6.91 15.82-13.09 0-5-4.17-9.49-10.84-11.84 2.87-2.35 4.41-5.24 4.41-8.32 0-5.75-5.55-10.8-13.9-12.72-2-6.12-10.1-10.53-19.94-10.74-2.12-6.11-10.43-10.46-20.36-10.52-2.2-4.38-7.82-7.78-14.78-8.92-.67-7.08-9.88-12.7-21.09-12.7z",
    className: "speedlimit20_before_svg__cls-4"
  }), /*#__PURE__*/React.createElement("g", {
    className: "speedlimit20_before_svg__cls-68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-127.56 1024.12c0-6 7.06-11 16.35-12.07-3.07-2.16-5-5-5-8.09 0-5.81 6.55-10.67 15.33-11.94a8 8 0 01-.73-3.25c0-6.17 7.37-11.25 17-12.13v-.14c0-6.78 8.89-12.27 19.86-12.27a31.39 31.39 0 015.92.55c3.5-3.48 9.74-5.78 16.83-5.78a29 29 0 0111.3 2.18c3.33-3.22 9-5.42 15.58-5.65 3.5-3.52 9.76-5.88 16.94-5.88A30 30 0 0111 951c-3.17-4.18-10-7.08-18-7.08-7.17 0-13.44 2.36-16.93 5.88-6.56.24-12.26 2.43-15.59 5.66a28.85 28.85 0 00-11.3-2.19c-7.13 0-13.36 2.33-16.87 5.81a31.39 31.39 0 00-5.92-.55c-11 0-19.86 5.49-19.86 12.27v.15c-9.59.87-17 6-17 12.12a7.93 7.93 0 00.72 3.25c-8.78 1.27-15.33 6.13-15.33 11.94 0 3.1 1.88 5.93 5 8.09-9.3 1-16.36 6-16.36 12.07 0 4.74 4.37 8.85 10.74 10.89a8.56 8.56 0 01-1.86-5.19z",
    className: "speedlimit20_before_svg__cls-69"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "speedlimit20_before_svg__Wolken"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-26.42 182.87c8.55-20.09 30.17-34.43 55.69-34.43 25.22 0 46.68 14 55.43 33.68a45.84 45.84 0 0111.3-1.55c23 0 41.69 16.64 41.69 37.17S119 254.91 96 254.91H-12.42c-23 0-41.7-16.64-41.7-37.17 0-16.13 11.6-29.74 27.7-34.87zM1145 130.44c14.36-33.74 50.66-57.83 93.53-57.83 42.35 0 78.4 23.48 93.1 56.57a76.9 76.9 0 0118.95-2.61c38.69 0 70 28 70 62.44s-31.35 62.44-70 62.44H1168.5c-38.68 0-70-28-70-62.44-.03-27.1 19.5-49.93 46.5-58.57zM528.16 148.92c-9.29-21.84-32.8-37.43-60.55-37.43-27.42 0-50.75 15.2-60.28 36.62a49.77 49.77 0 00-12.27-1.69c-25 0-45.34 18.1-45.34 40.42s20.3 40.43 45.34 40.43H513c25 0 45.34-18.1 45.34-40.43-.05-17.54-12.66-32.32-30.18-37.92zM819.87 307.65c8.07-19 28.47-32.49 52.56-32.49 23.8 0 44.06 13.19 52.32 31.78a43.72 43.72 0 0110.65-1.46c21.74 0 39.35 15.71 39.35 35.08s-17.61 35.09-39.35 35.09H833.08c-21.74 0-39.36-15.71-39.36-35.09 0-15.22 10.95-28.05 26.15-32.91z",
    className: "speedlimit20_before_svg__cls-25"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedlimit20Before);
export default __webpack_public_path__ + "static/media/speedlimit20.before.a7c83276.svg";
export { ForwardRef as ReactComponent };